export const USER_EMAIL = 'emailToDisplay';
export const CHANGE_SS_TOASTER = 'changeSsToaster';
export const CORPORATE_EMAIL = 'corporateEmail';
export const LAST_LOGIN_OPTION = 'lastLoginOption';
export const CHANGE_CONNECTION_SETTINGS_TOASTER = 'changeConnSettingsToaster';
export const DISPLAY_WARNING_TOASTER = 'displayWarningToaster';
export const DISPLAY_ERROR_TOASTER = 'displayErrorToaster';
